import React, { useState } from 'react';
import styled from 'styled-components';

import { MdKeyboardArrowDown } from 'react-icons/md'

const Wrapper = styled.div`
    border: 1px solid var(--darkgreen);
    width: 3vw;
    min-width: 85px;
    padding: 5px 5px 5px 10px;
    position: relative;
    margin-bottom: 10px;

    font-size: max(0.7vw, 12px);

    background-color: white;

    visibility: ${props => props.amount == 'N/A' ? 'hidden' : 'visible'};

    .selected{
        display: flex;
        justify-content: space-between;
        align-items: center;

        color: var(--darkgreen);
        font-weight: 600;
      
      svg {
        padding: 0!important;
      }
    }
    
    cursor: pointer;

    .dropdown{
        z-index: 2;
        position: absolute;
        top: 100%;
        left: 0;

        display: ${props => props.open ? "auto" : "none"};
        background-color: rgb(250, 250, 250);
        border: 1px solid var(--darkgreen);

        width: 100%;

        border-radius: 5px;

        div{
            padding: 10px 10px;
            color: var(--darkgreen);
            //font-weight: 500;
            
            &:hover{
                background-color: rgba(0, 0, 0, 0.025);
            }
        }
    }
`;

export default function Dropdown({ amount, setAmountIndex, variants })
{
    const [open, setOpen] = useState(false);

    const handleChangeAmount = (e) => {
        setAmountIndex(parseInt(e.target.getAttribute('name')))
        setOpen(false);
    }

    return(
        <Wrapper open={open} amount={amount}>
            <div onClick={() => setOpen(!open)} className="selected">
                {amount}
                <MdKeyboardArrowDown style={{ fontSize: '2.25vh', paddingTop: 3 }}/>
            </div>
            
            <div className="dropdown">
                {variants.map((variant, index) => {
                    return(
                        <div 
                            key={variant.option}
                            name={index}
                            onClick={handleChangeAmount}
                        >
                            {variant.option}
                        </div>
                    )
                })}
            </div>
        </Wrapper>
    )
}